import { Component, inject } from '@angular/core';
import { LoggerService } from '@tytapp/common';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface YouTubeBlock extends ContentBlock {
    html_embed: string;
}

@Component({
    template: `<div class="embed" [innerHTML]="block.html_embed | trustHtml"></div>`,
    styles: [
        `
        :host > div {
            aspect-ratio: 16/9;
        }
        ::ng-deep iframe {
            width: 100%;
            height: 100%;
        }
        `
    ]
})
export class ViewComponent extends ContentBlockViewComponent<YouTubeBlock> {
}

@Component({
    template: `
        <ng-container *ngIf="block.html_embed">
            <div class="youtube" style="text-align: center;" [innerHTML]="block.html_embed | trustHtml">
            </div>
        </ng-container>
        <ng-container *ngIf="!block.html_embed">
            <form (submit)="fetchYouTube(block)">
            <mat-form-field appearance="outline">
                <mat-label>Enter YouTube URL</mat-label>
                <input name="youtubeUrl" type="text" matInput [(ngModel)]="block.__youtubeUrl"
                    placeholder="https://www.youtube.com/watch?v=ABCDEF" [disabled]="locked" />
            </mat-form-field>
            <button mat-button color="primary" [disabled]="!block.__youtubeUrl" [disabled]="locked">
                <mat-icon>add</mat-icon>
                Add YouTube Embed
            </button>
            </form>
        </ng-container>
    `,
    styles: [
        `
        .youtube {
            aspect-ratio: 16/9;
        }

        ::ng-deep iframe {
            width: 100%;
            height: 100%;
        }

        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<YouTubeBlock> {
    private logger = inject(LoggerService);

    async fetchYouTube(block: YouTubeBlock) {
        try {
            let url = block['__youtubeUrl'];
            let id: string;

            if (url.startsWith('https://youtube.com')) {
                id = url.replace(/https:\/\/youtube.com\/watch\?v=/, '');
            } else if (url.startsWith('https://www.youtube.com')) {
                id = url.replace(/https:\/\/www\.youtube\.com\/watch\?v=/, '');
            } else if (url.startsWith('https://youtu.be/')) {
                id = url.replace(/https:\/\/youtu\.be\//, '');
            } else if (url.startsWith('https://www.youtube.com/embed/')) {
                id = url.replace(/https:\/\/www\.youtube\.com\/embed\//, '');
            }

            block.html_embed = `
                <iframe width="560" height="315"
                    src="https://www.youtube.com/embed/${id}"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>`;
        } catch (e) {
            this.logger.error(`Could not add YouTube video embed:`);
            this.logger.error(e);
            alert(`Could not add YouTube video! Is it a valid YouTube URL?`);
        }
    }

}

export const YOUTUBE_BLOCK_TYPE: ContentBlockType<YouTubeBlock> = {
    id: 'youtube',
    label: 'YouTube Video',
    icon: 'title',
    template: {

    },
    preview: {
        html_embed: `
        <iframe width="560" height="315" src="https://www.youtube.com/embed/mJ_HabP980M?si=jGdVhzmkKFfYsjkc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        `
    },
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
